import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Avatar, Chip } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { OverallCurrentPage, User } from './context';

import { useNavigate } from "react-router-dom";
const drawerWidth = 240;


function DrawerAppBar(props) {
    const { fullUser, isAdmin } = React.useContext(User);
    const { setCurrentPage } = React.useContext(OverallCurrentPage);
    const { window } = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const navigate = useNavigate();

    const navItems = props.navItems

    const handleDrawerToggle = () => {
        if (navItems !== undefined && navItems.length > 0) {
            setMobileOpen((prevState) => !prevState);
        }
    };
    const handleMenuClick = (value) => {
        let handler = props.handleMenuClick || (() => { });
        handler(value);
    }

    const drawer = (
        <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
            <Typography variant="h6" sx={{ my: 2 }}>
                {props.title}
            </Typography>
            <Divider />

            <List>
                {navItems.map((item) => (
                    <ListItem key={item.label} disablePadding onClick={() => navigate(item.value)} >
                        <ListItemButton sx={{ textAlign: 'center' }}>
                            <ListItemText primary={item.label} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar component="nav">
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2 }}
                    >
                        <img src="./Ki Reply - RUNNING MAN RGB.png" style={{ maxWidth: '50px' }} />
                        {/* <MenuIcon /> */}
                    </IconButton>
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{ flexGrow: 1, display: { xs: 'block' } }}
                    >
                    </Typography>
                    <Box sx={{ display: { xs: 'block' }, cursor: 'pointer' }} onClick={() => navigate('/')}>
                        {isAdmin && (
                            <Typography
                                variant='h6'
                                component="div"
                                color="error"
                                sx={{ flexGrow: 1, mr: 5 }}

                            >Admin
                            </Typography>
                        )}
                    </Box>
                    <Box sx={{ display: { xs: 'block' }, cursor: 'pointer' }} onClick={() => navigate('/')}>
                        <Typography
                            variant='h6'
                            component="div"
                            sx={{ flexGrow: 1, mr: 5 }}

                        >Kicode
                        </Typography>
                    </Box>
                    <Box>
                        <Avatar>{props?.user[0]?.toUpperCase()}</Avatar>
                    </Box>
                    <Box>
                        <IconButton onClick={props.signOut}>
                            <LogoutIcon color="error" />
                        </IconButton>
                    </Box>
                </Toolbar>
            </AppBar>
            <nav>
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: 'block' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                >
                    {drawer}
                </Drawer>
            </nav>
            <Box component="main" sx={{ p: 3, width: '100%' }}>
                <Toolbar />
                {props.children}
                <Typography>

                </Typography>
            </Box>
        </Box>
    );
}

DrawerAppBar.propTypes = {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
};

export default DrawerAppBar;
